import { getTransactionsStats } from '../../../services/pos/transactions';

export const TRANSACTIONS_STATS_FETCH = 'TRANSACTIONS_STATS_FETCH';
export const TRANSACTIONS_STATS_SUCCESS = 'TRANSACTIONS_STATS_SUCCESS';
export const TRANSACTIONS_STATS_ERROR = 'TRANSACTIONS_STATS_ERROR';

export const getTransactionsStatsAction = () => async (dispatch) => {
  dispatch({ type: TRANSACTIONS_STATS_FETCH });
  try {
    const payload = await getTransactionsStats();
    payload.lastUpdate = new Date();
    dispatch({ type: TRANSACTIONS_STATS_SUCCESS, payload });
  } catch (error) {
    const errorResponse = error.response;

    let errorCode;
    switch (errorResponse?.data?.error) {
      case 'INVALID_CREDENTIALS':
        errorCode = errorResponse?.data?.error;
        break;
      default:
        errorCode = 'UNKNOWN_ERROR';
    }

    dispatch({ type: TRANSACTIONS_STATS_ERROR, error: errorCode });
  }
};
